<mat-card
  class="default has-progress-bar"
  [class.notExpanded]="!expanded"
  [class.expanded]="expanded"
  fxLayout="column"
>
  <mat-progress-bar [mode]="(progress$ | async) ? 'indeterminate' : 'determinate'"></mat-progress-bar>
  <mat-card-title fxLayout="row" fxLayoutAlign="space-between center">
    <span>
      <ng-container *ngIf="title; else defaultTitleEl">
        {{ title }}
      </ng-container>
      <ng-template #defaultTitleEl>
        {{ 'messages-card.messages' | translate }}
      </ng-template>
    </span>
    <div fxFlex></div>
    <button
      mat-icon-button
      type="button"
      (click)="refresh$.next(); $event.stopPropagation()"
      [disabled]="progress$ | async"
    >
      <mat-icon>refresh</mat-icon>
    </button>
    <button
      *ngIf="!expanded && patient && !embedded"
      type="button"
      mat-icon-button
      (click)="openWindow()"
      [matTooltip]="'messages-card.new-window' | translate"
    >
      <mat-icon>open_in_new</mat-icon>
    </button>
  </mat-card-title>
  <mat-card-content
    [fxFlex]="expanded ? '' : undefined"
    *ngIf="messages$ | async as messages"
    #messageHistory
    class="message-history"
    [style.minHeight.px]="embedded ? 150 : 0"
  >
    <ul *ngIf="messages.length > 0; else noMessages">
      <li
        *ngFor="let message of messages"
        [class.messageIn]="message.direction === direction.INCOMING"
        [class.messageOut]="message.direction === direction.OUTGOING"
        [class.note]="message.isNote"
        (contextmenu)="onContextMenu($event, message)"
      >
        <div class="content">
          <div class="message">
            <div class="bubble" *ngIf="message.text?.length > 0">
              <p *ngIf="message.isNote || message.method === 'sms' || (message.internal && !message.method)">
                <ng-container *ngIf="message.show === 'externalMessage'">{{ message.externallySentMessage }}</ng-container>
                <ng-container *ngIf="message.show === 'text'">{{ message.text }}</ng-container>
                <ng-container *ngIf="!message.show || message.show === 'translatedText'">{{ message.translatedText || message.text }}</ng-container>

                <ng-container *ngFor="let mediaObj of message.mediaObjects">
                  <div class="media-container" *ngIf="mediaObj.url">
                    <img class="message-media" [src]="mediaObj.url" (error)="mediaObj.url = null">
                  </div>

                  <div class="preview-link" *ngIf="!mediaObj.url" (click)="refreshMedia(message)">
                    {{ 'messages-card.show-images'| translate }}
                  </div>
                </ng-container>
              </p>
              <p *ngIf="message.method === 'email'">
              <strong>{{message.subject}}</strong><br>
              {{extractFirstLine(message.text)}}
              <span class="preview-link" (click)="openEmailPreview(message)">
                {{ 'messages-card.preview-email'| translate }}
              </span>
              </p>
            </div>

            <div *ngIf="message.attachments" class="attachments" fxLayout="row">
              <a
                *ngFor="let attachment of message.attachments"
                [href]="attachment"
                target="_blank"
              >
                <img
                  *ngIf="isImage(attachment); else attachmentIcon"
                  [src]="attachment"
                />
                <ng-template #attachmentIcon>
                  <mat-icon>attachment</mat-icon>
                </ng-template>
              </a>
            </div>
          </div>
          <div
            class="mt-1 text-sm"
            fxLayout="row"
            [fxLayoutAlign]="
              message.direction === direction.INCOMING
                ? 'start center'
                : 'end center'
            "
            fxLayoutGap="0.25rem"
            [matTooltip]="message.tooltip || message.getTooltip(clinic)"
            [matMenuTriggerFor]="contextMenu"
            (click)="contextualMessage = message"
          >
            <mat-icon class="text-muted small-icon" *ngIf="message.isNote"
              >note</mat-icon
            >
            <mat-icon
              class="text-muted small-icon"
              *ngIf="message.method === 'sms'"
              >textsms</mat-icon
            >
            <mat-icon
              class="text-muted small-icon"
              *ngIf="message.method === 'email'"
              >email</mat-icon
            >
            <mat-icon *ngIf="message.internal" class="text-muted small-icon">lock</mat-icon>
            <mat-icon *ngIf="message.translatedText" matTooltip="Translated message" class="text-muted small-icon">translate</mat-icon>
            <span class="text-secondary">
              {{ message.createdAt.fromNow() }}
              <ng-container *ngIf="message.clinician; else systemSent">
                &mdash; {{ message.clinician?.abbreviation }}
              </ng-container>
              <ng-template #systemSent>
                <ng-container *ngIf="message.direction === direction.OUTGOING">
                  &mdash; {{ 'messages-card.sent-by-system' | translate }}
                </ng-container>
              </ng-template>
            </span>
            <span *ngIf="!message.isNote" class="text-muted">
              {{ message.status }}
            </span>
            <!-- <span *ngIf="message.isNote" class="text-muted">
              internal note
            </span> -->
          </div>
        </div>
      </li>
    </ul>

    <mat-menu #contextMenu="matMenu">
      <ng-container *ngIf="contextualMessage">
        <div
          mat-menu-item
          *ngIf="contextualMessage.translatedText && contextualMessage.show === 'text'"
          (click)="contextualMessage.show = 'translatedText'"
        >
          View translated message
        </div>
        <div
          mat-menu-item
          *ngIf="contextualMessage.translatedText && contextualMessage.show !== 'text'"
          (click)="contextualMessage.show = 'text'"
        >
          View original message
        </div>
        <div
          mat-menu-item
          *ngIf="contextualMessage.internal && contextualMessage.externallySentMessage && contextualMessage.show === 'externalMessage'"
          (click)="contextualMessage.show = 'translatedText'"
        >
          View internally sent message
        </div>
        <div
          mat-menu-item
          *ngIf="contextualMessage.internal && contextualMessage.externallySentMessage && contextualMessage.show !== 'externalMessage'"
          (click)="contextualMessage.show = 'externalMessage'"
        >
          View externally sent message
        </div>
      </ng-container>
      <div mat-menu-item *ngIf="contextualMessage">
        <ng-container
          *ngIf="contextualMessage.direction === direction.INCOMING"
        >
          {{ 'messages-card.received-at' | translate }}
        </ng-container>
        <ng-container
          *ngIf="contextualMessage.direction === direction.OUTGOING"
        >
          {{ 'messages-card.sent-at' | translate }}
        </ng-container>
        {{ contextualMessage.createdAt | momentDateTime: 'local' }}
      </div>
      <div
        mat-menu-item
        *ngIf="
          contextualMessage?.clinician && contextualMessage?.clinician.name
        "
      >
        {{ 'messages-card.sent-by' | translate }}
        {{ contextualMessage.clinician.name }}
      </div>
      <button
        *ngIf="contextualMessage?.workflowId"
        mat-menu-item
        [routerLink]="['/settings', 'workflows', contextualMessage.workflowId]"
      >
        {{ 'messages-card.goto-workflow' | translate }}
      </button>
      <button
        *ngIf="contextualMessage?.appointmentId"
        mat-menu-item
        [routerLink]="['/patient', contextualMessage.patientId, 'appointment', contextualMessage.appointmentId]"
      >
        {{ 'messages-card.goto-appointment' | translate }}
      </button>
      <button *ngIf="contextualMessage?.id" mat-menu-item>
        <mmx-copy-text [copyValue]="contextualMessage.id">{{
          'messages-card.copy-message' | translate
        }}</mmx-copy-text>
      </button>
      <button *ngIf="contextualMessage?.workflowId" mat-menu-item>
        <mmx-copy-text [copyValue]="contextualMessage.workflowId">{{
          'messages-card.copy-workflow' | translate
        }}</mmx-copy-text>
      </button>
      <button *ngIf="contextualMessage?.sid" mat-menu-item>
        <mmx-copy-text [copyValue]="contextualMessage.sid">{{
          'messages-card.copy-sid' | translate
        }}</mmx-copy-text>
      </button>
    </mat-menu>

    <ng-template #noMessages>
      <div *ngIf="isLoading" style="padding-bottom: 1em">
        {{ 'messages-card.loading' | translate }}
      </div>
      <div *ngIf="!isLoading" style="padding-bottom: 1em">
        {{ 'messages-card.no-messages' | translate }}
      </div>
    </ng-template>
  </mat-card-content>
  <mat-card-footer *ngIf="patient && form" class="p-4">
    <form
      class="full-width"
      fxLayout="column"
      fxLayoutGap="5px"
      [formGroup]="form"
    >
      <mat-form-field fxFlex="grow" hideRequiredMarker>
        <mat-label>{{ 'messages-card.message' | translate }}</mat-label>
        <textarea
          matInput
          formControlName="messageBody"
          #messageBody
          [placeholder]="'messages-card.message-hint' | translate"
          mat-autosize
          matAutosizeMinRows="1"
          matAutosizeMaxRows="5"
        ></textarea>
      </mat-form-field>

      <div fxLayout="row" fxLayoutAlign="space-between center">
        <span>
          <button
            mat-icon-button
            type="button"
            [matTooltip]="'messages-card.use-template' | translate"
            [matMenuTriggerFor]="templateMessageComponentMenu?.menu">
            <mat-icon>quickreply</mat-icon>
          </button>
          <button
            mat-icon-button
            *ngIf="clinic?.modules?.internalMessaging"
            (click)="isInternalMessage = !isInternalMessage"
            [color]="isInternalMessage ? 'primary': ''"
            matTooltip="Send as a HIPAA-compliant message"
          >
            <mat-icon *ngIf="isInternalMessage">lock</mat-icon>
            <mat-icon *ngIf="!isInternalMessage">lock_open_right</mat-icon>
          </button>
          <button
            *ngIf="patient.canText && patient.language && patient.language !== 'en'"
            mat-icon-button
            type="button"
            [matTooltip]="'Translate to ' + (patient.language | languageName)"
            (click)="translate()"
          >
            <mat-icon>translate</mat-icon>
          </button>
        </span>
        <ng-container *ngIf="translating$ | async; else showSendButton">
          <div style="padding-right: 3px">
            <mat-progress-spinner
              mode="indeterminate"
              color="primary"
              diameter="30"
            ></mat-progress-spinner>
          </div>
        </ng-container>
        <ng-template #showSendButton>
          <button
            *ngIf="patient.language === 'en' || !translatedText; else showSendMenu"
            mat-flat-button
            type="submit"
            color="primary"
            (click)="sendMessage()"
            [disabled]="!patient.canText || (progress$ | async)"
          >
            <mat-icon>send</mat-icon>
            {{ 'messages-card.send-text' | translate }}
          </button>
        </ng-template>
        <ng-template #showSendMenu>
          <button
            mat-flat-button
            color="accent"
            type="button"
            [disabled]="!patient.canText || (progress$ | async)"
            [matMenuTriggerFor]="sendMenu"
          >
            <mat-icon>send</mat-icon>
            {{ 'messages-card.send-text' | translate }}
          </button>
        </ng-template>
      </div>
    </form>

    <mmx-template-message
      #templateMessageComponentMenu
      [language]="patient.language"
      (templateMessage)="onTemplateMessageSelected($event)">
    </mmx-template-message>

    <mat-menu #sendMenu="matMenu">
      <button mat-menu-item (click)="sendMessage(false)">
        {{ 'messages-card.send-written' | translate }}
      </button>

      <button mat-menu-item (click)="sendMessage(true)">
        {{ 'messages-card.send-translation' | translate }}
      </button>
    </mat-menu>

    <small *ngIf="(translating$ | async) === false && translationError">
      {{ 'messages-card.error-translating' | translate }}
    </small>

    <ng-container *ngIf="(translating$ | async) === false && !translationError && translatedText">
      <span class="text-secondary">Translation:</span>
      <div>
        {{ translatedText }}
      </div>
      <div fxLayout="row" fxLayoutAlign="end center">
        <button mat-stroked-button type="button" (click)="useTranslation()">Use translation</button>
      </div>
    </ng-container>

    <ng-container *ngIf="(cannotTextReason$ | async) as reason">
      <div *ngIf="reason === CANNOT_TEXT_REASON.NO_PHONE_NUMBER" class="text-warn text-sm">
        {{ 'messages-card.patient-no-phone' | translate }}
      </div>

      <div *ngIf="reason === CANNOT_TEXT_REASON.LANDLINE" class="text-warn text-sm">
        {{ 'messages-card.patient-no-phone-text' | translate }}
      </div>

      <div *ngIf="reason === CANNOT_TEXT_REASON.UNSUBSCRIBED" class="text-warn text-sm">
        {{ 'messages-card.patient-unsubscribed' | translate }}
      </div>

      <div *ngIf="reason === CANNOT_TEXT_REASON.BLOCKED" class="text-warn text-sm">
        {{ 'messages-card.patient-not-contacted' | translate }}
      </div>
    </ng-container>

    <div class="text-accent text-sm" *ngIf="typings?.length > 0">
      <div *ngFor="let typing of typings">
        {{ typing.clinician.name }} {{ 'messages-card.is-typing' | translate }}
      </div>
    </div>
  </mat-card-footer>
</mat-card>
